<template>
  <v-footer padless dark color="primary">
    <v-container class="footer">  
      <v-row class="pb-5">
        <v-col cols="12" sm="6" md="3">
          <div class="logos">
            <img src="../assets/logo.png" height="40" alt="Agram logo">
            <img src="../assets/agram_text.png" height="40" alt="Agram logo">
          </div>
          <span class="py-2" style="line-height: 1.2;">Agram infotech Pvt. Ltd Company <br>Panitanki Birgunj, Nepal</span>
          <div class="my-4">
            <div v-for="(contact, c) in contacts" :key="c">
              <v-icon size="16">{{ contact.icon }}</v-icon>
              <span class="ml-2">{{ contact.title }}</span>
            </div>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3" class="services">
          <div class="other-title">
            <span @click.stop="goto('/company')">Company</span>
          </div>
          <div class="links">
            <span v-for="(c, i) in company" :key="i" @click.stop="goto(c.to)">{{ c.title }}</span>
          </div>
        </v-col>

        <v-col cols="12" sm="6" md="3" class="services">
          <div class="other-title">
            <span @click.stop="goto('/services')">Services</span>
          </div>
          <div class="links">
            <span v-for="(service, s) in services" :key="s" @click.stop="goto(service.to)">{{ service.title }}</span>
          </div>
        </v-col>
        <v-col cols="12" sm="6" md="3">
          <div class="other-title">
            <span @click.stop="goto('/solutions')">Solutions</span>
          </div>
          <div class="links">
            <span v-for="(sol, s) in solutions" :key="s" @click.stop="goto(sol.to)">{{ sol.title }}</span>
          </div>
          <div class="other-title mt-4">
            <span @click.stop="goto('/products')">Products</span>
          </div>
        </v-col>
      </v-row> 
      <div style="height: 1px; background-color: white;" class="mb-5"></div>
      <div class="d-sm-flex justify-space-between">
        <div>Copyright @{{ new Date().getFullYear() }} Agram Infotech</div>
        <div class="social mt-5 mt-sm-0">
          <a v-for="(social, s) in socials" :key="s" target="_blank" :href="social.href">
            <v-icon size="20" class="icon">{{ social.icon }}</v-icon>
          </a>  
        </div>
      </div>  
    </v-container>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    contacts: [
      { icon: 'mdi-email', title: 'info@agramcloud.com' },
      { icon: 'mdi-phone', title: '+977 9802057014' },
    ], 
    services: [
      { title: 'Mobile App Development', to: '/services/mobile-app-development' },
      { title: 'Web App Development', to: '/services/web-app-development' },
      { title: 'Digital Marketing', to: '/services/digital-marketing' },
      { title: 'Ecommerce', to: '/services/ecommerce' },
      { title: 'On Demand App', to: '/services/on-demand-app' }
    ],
    company: [
      { title: 'About Us', to: '/company/about-us' },
      { title: 'Portfolio', to: '/company/portfolio' },
      { title: 'Career', to: '/company/career' },
      { title: 'Gallery', to: '/company/gallery' }
    ],
    solutions: [
      { title: 'IoT for Agriculture', to: '/solutions/iot-solution-for-agriculture' },
      { title: 'IoT for Flood Monitor', to: '/solutions/iot-solution-for-flood-monitor' },
    ],
    socials: [
      { title: 'Facebook', icon: 'mdi-facebook', href: 'https://www.facebook.com/agraminfotechbirgunj/' },
      { title: 'Linkedin', icon: 'mdi-linkedin', href: 'https://www.linkedin.com/company/agraminfotech/' },
      { title: 'Twitter', icon: 'mdi-twitter', href: 'https://www.twitter.com/agraminfotech/' }  ,
      { title: 'Instagram', icon: 'mdi-instagram', href: 'https://www.instagram.com/agraminfotech/' }  
    ]  
  }),
  methods: {
    goto(link) {
      if(this.$route.path != link) this.$router.push(link)
    }
  } 
}
</script>

<style scoped>
.footer { margin: 50px auto 30px auto; }
.social a {
  padding: 10px;
  border: 1px solid white;  
  margin-right: 10px;
  transition: 250ms ease-in-out;
  text-decoration: none;
}
.social a:last-child { margin-right: 0 !important; }
.social a:hover {
  background-color: white;
  border-radius: 50%;  
}
.social a:hover .icon { color: blue; }
.other-title {
  font-size: 25px;
  margin-bottom: 8px;
}
.other-title span { 
  border-bottom: 1px solid white;
  cursor: pointer;
}
.links {
  display: inline-flex;
  flex-direction: column;
  grid-gap: 10px;
}
.links span {
  color: white !important;
  line-height: 1;
  border-bottom: 1px solid transparent;
  transition: ease-in-out 250ms;
  cursor: pointer;
}
.links span:hover { border-bottom: 1px solid white; }
.links span:last-child { margin-bottom: 0 !important; }
</style>